import type { ComponentProps } from 'react';
import { MaskedInput } from '@/components/shared/masked-input';
import { centsToInput, parseMoney } from '@/lib/format';

/** Campo de dinheiro controlado em centavos (usar com Controller ou estado). */
export function MoneyInput({
  value,
  onChange,
  ...props
}: Omit<ComponentProps<typeof MaskedInput>, 'mask' | 'value' | 'onChange'> & { value: number; onChange: (cents: number) => void }) {
  return <MaskedInput mask="money" value={centsToInput(value)} onChange={(e) => onChange(parseMoney(e.target.value))} {...props} />;
}
